import { ErrorBoundary, ErrorBoundaryProps } from '@sentry/react';
import { createElement } from 'react';

export type UseErrorBoundaryWrapper = (props: ErrorBoundaryProps) => React.ReactElement;

export function createErrorBoundary(getResetKey: () => number): UseErrorBoundaryWrapper {
  return function UseErrorBoundaryWrapper(props) {
    return createElement<ErrorBoundaryProps>(ErrorBoundary, {
      key: getResetKey(),
      ...props,
    });
  };
}
